export default {
    sidePill: {
        buy: 'BUY',
        sell: 'SELL',
    },
}
